/* KOJO custom layer — home sections B behaviour. Safe to load more than once.
   1) Video strip playback (video[data-kj-vs-video], rendered by snippets/kojo-hb-video.liquid with managed: true):
      - poster (data-poster) is set only when the rail comes within ~600px of the viewport;
      - the smallest MP4 rendition that covers the card (height x DPR, capped at 2x) is used (data-srcs, low -> high;
        a missing file falls back to the next one);
      - only the CAP most visible videos play (3 on desktop, 2 below 1100px); a hovered/focused card or one with sound
        on is promoted; everything else rests on its poster. Reduced motion: nothing autoplays.
   2) Sound toggle ([data-kj-sound]): one video with sound at a time; muted again when it stops playing. */
(function () {
  'use strict';
  if (window.__kjHomeB) return;
  window.__kjHomeB = true;
  var doc = document;
  var hasIO = 'IntersectionObserver' in window;
  var mqDesk = window.matchMedia ? window.matchMedia('(min-width: 1100px)') : null;
  var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var MIN_RATIO = 0.6;
  var vids = [];
  var boostSeq = 0;
  var raf = 0;

  function cap() { return mqDesk && mqDesk.matches ? 3 : 2; }
  function reduced() { return !!(mqReduce && mqReduce.matches); }

  function setPoster(v) {
    if (v.dataset.poster && !v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster);
  }
  function candidates(v) {
    if (!v._kjSrcs) v._kjSrcs = (v.dataset.srcs || '').split('|').filter(Boolean);
    return v._kjSrcs;
  }
  function pickIndex(v) {
    var list = candidates(v);
    if (list.length < 2) return 0;
    var h = (v.parentNode && v.parentNode.clientHeight) || v.clientHeight || 480;
    var need = h * Math.min(window.devicePixelRatio || 1, 2);
    /* list is ordered low -> high; when a 480p file is present it is first. 480p covers ~520 device px, 720p ~800. */
    var has480 = /SD-480p-/.test(list[0]);
    if (has480 && need <= 520) return 0;
    if (has480) return Math.min(1, list.length - 1);
    return 0;
  }
  function ensureSrc(v) {
    if (v.getAttribute('src')) return;
    var list = candidates(v);
    if (!list.length) return;
    if (v._kjIdx == null) v._kjIdx = pickIndex(v);
    setPoster(v);
    v.src = list[v._kjIdx];
  }
  function onError(e) {
    var v = e.currentTarget;
    var list = candidates(v);
    if (v._kjIdx == null || v._kjIdx >= list.length - 1) return;
    v._kjIdx += 1;
    var wasWanted = v._kjWant;
    v.src = list[v._kjIdx];
    if (wasWanted) { v._kjWant = false; play(v); }
  }
  function play(v) {
    ensureSrc(v);
    v._kjWant = true;
    if (!v.paused) return;
    var p = v.play && v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function pause(v) {
    v._kjWant = false;
    if (!v.paused) v.pause();
  }
  function soundOn(v) { return !v.muted; }

  function schedule() {
    if (raf) return;
    var run = function () { raf = 0; update(); };
    raf = window.requestAnimationFrame ? window.requestAnimationFrame(run) : setTimeout(run, 16);
  }
  function update() {
    vids = vids.filter(function (v) { return v.isConnected; });
    var eligible = [];
    vids.forEach(function (v, i) {
      v._kjOrder = i;
      var visible = (v._kjRatio || 0) >= MIN_RATIO || (soundOn(v) && (v._kjRatio || 0) > 0);
      if (visible && (!reduced() || soundOn(v))) eligible.push(v);
    });
    eligible.sort(function (a, b) {
      var sa = soundOn(a) ? 1 : 0, sb = soundOn(b) ? 1 : 0;
      if (sa !== sb) return sb - sa;
      var ba = a._kjBoost || 0, bb = b._kjBoost || 0;
      if (ba !== bb) return bb - ba;
      return a._kjOrder - b._kjOrder;
    });
    var n = cap();
    var keep = eligible.slice(0, n);
    vids.forEach(function (v) {
      if (keep.indexOf(v) > -1) play(v); else pause(v);
    });
  }

  var visIO = hasIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { en.target._kjRatio = en.isIntersecting ? en.intersectionRatio : 0; });
    schedule();
  }, { threshold: [0, 0.25, 0.5, 0.6, 0.75, 0.9, 1] }) : null;

  /* posters for a whole rail as soon as it approaches the viewport (cards hidden in the rail's overflow never
     "intersect" on their own, so observe the rail, not each video) */
  var nearIO = hasIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      Array.prototype.forEach.call(en.target.querySelectorAll('video[data-poster]'), setPoster);
      nearIO.unobserve(en.target);
    });
  }, { rootMargin: '600px 0px' }) : null;

  function promote(e) {
    var item = e.target.closest && e.target.closest('[data-kj-vs-item]');
    if (!item) return;
    var v = item.querySelector('video[data-kj-vs-video]');
    if (!v || (v._kjBoost && v._kjBoost === boostSeq)) return;
    v._kjBoost = ++boostSeq;
    schedule();
  }

  function initVideos(ctx) {
    var root = ctx && ctx.querySelectorAll ? ctx : doc;
    Array.prototype.forEach.call(root.querySelectorAll('video[data-kj-vs-video]'), function (v) {
      if (v._kjVs) return;
      v._kjVs = true;
      v.muted = true;
      v.addEventListener('error', onError);
      vids.push(v);
      if (visIO) visIO.observe(v);
      var rail = v.closest('[data-kj-track]') || v.closest('section') || v.parentNode;
      if (nearIO && rail && !rail._kjNear) { rail._kjNear = true; nearIO.observe(rail); }
      if (!hasIO) { setPoster(v); v._kjRatio = 1; }
    });
    schedule();
  }

  if (mqDesk && mqDesk.addEventListener) mqDesk.addEventListener('change', schedule);
  if (mqReduce && mqReduce.addEventListener) mqReduce.addEventListener('change', schedule);
  if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
    doc.addEventListener('mouseover', promote);
  }
  doc.addEventListener('focusin', promote);
  doc.addEventListener('shopify:section:load', function (e) { initVideos(e.target); });
  /* browsers may pause muted videos while the tab is hidden: re-sync when it is shown again */
  doc.addEventListener('visibilitychange', function () { if (doc.visibilityState === 'visible') schedule(); });

  /* ---------- sound toggle ---------- */
  function videoOf(btn) {
    var item = btn.closest('[data-kj-vs-item]');
    return item ? item.querySelector('video') : null;
  }
  function setBtn(btn, on) {
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var label = on ? btn.getAttribute('data-label-off') : btn.getAttribute('data-label-on');
    if (label) btn.setAttribute('aria-label', label);
  }
  function muteOthers(except) {
    Array.prototype.forEach.call(doc.querySelectorAll('[data-kj-sound][aria-pressed="true"]'), function (b) {
      if (b === except) return;
      var v = videoOf(b);
      if (v) v.muted = true;
      setBtn(b, false);
    });
  }

  doc.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-kj-sound]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var v = videoOf(btn);
    if (!v) return;
    var turnOn = v.muted || btn.getAttribute('aria-pressed') !== 'true';
    if (turnOn) {
      muteOthers(btn);
      if (v.hasAttribute('data-kj-vs-video')) {
        ensureSrc(v);
        v._kjBoost = ++boostSeq;
      } else if (!v.getAttribute('src') && v.dataset.src) {
        v.src = v.dataset.src;
      }
      v.muted = false;
      v._kjWant = true;
      var p = v.play && v.play();
      if (p && p.catch) p.catch(function () { v.muted = true; setBtn(btn, false); schedule(); });
    } else {
      v.muted = true;
    }
    setBtn(btn, turnOn);
    schedule();
  });

  /* when a video with sound stops playing (scrolled away / paused by the cap), mute it again */
  doc.addEventListener('pause', function (e) {
    var v = e.target;
    if (!v || v.tagName !== 'VIDEO' || v.muted) return;
    var item = v.closest('[data-kj-vs-item]');
    if (!item) return;
    v.muted = true;
    var btn = item.querySelector('[data-kj-sound]');
    if (btn) setBtn(btn, false);
  }, true);

  initVideos(doc);
})();
